import styled from "styled-components";
import COLORS from "styles/colors";

export const Container = styled.div`
  width: 100%;
  /*height: 707px;*/
  background: rgb(90, 24, 154);
  /*background-image: ${({ background }) => "url(" + background + ")" };
  margin-top: -15rem; */
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (min-width: 992px) {
    background-image: ${({ background }) => "url(" + background + ")" };
    background-position: center;
    background-size: cover;
  }

  .ellipseWrapper {
    @media all and (max-width: 550px) {
      .ellipse1 {
          position: absolute;
          right: 0;
          top: 100px;
        img {
          width: 80px;
        }
      }
      .ellipse2 {
        img {
          width: 200px;
        }
      }
    }
  }

  .ellipse1 {
    position: absolute;
    right: 170px;
    top: 170px;
  }
  .ellipse2 {
    position: absolute;
    /* right: 170px; */
    /* top: 170px; */
    left: 0;
    width: 5rem;
    bottom: 0;
  }
  .wrapper {
    width: 100%;
    margin: 10rem 9rem;
    display: flex;
    align-items: center;
    /*flex-wrap: wrap-reverse;*/
    position: relative;
    justify-content: space-around;
    flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};
    overflow: hidden;
    .text-content {
      /*margin-top: 6rem;
      @media all and (max-width: 1024px) {
        margin-top: 0rem;
      }*/
      span {
        margin-bottom: 12px;
        letter-spacing: 0.15em;
      }

      .header {
        font-size: 3.6rem;
        line-height: 4.5rem;
        max-width: 396px;
        margin: 12px 0;
      }

      .desc {
        font-size: 1.7rem;
        line-height: 2.8rem;
        max-width: 396px;
        margin: 8px 0;
      }

      .btn {
        margin-top: 4.8rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        div {
          display: flex;
          align-items: center;
          font-weight: normal;
          @media all and (max-width: 391px) {
            margin-top: 20px;
          }
          svg {
            margin: 0 10px;
          }
        }
        .sec-link {
          color: rgba(181, 206, 255, 1);
          background: transparent;
          font-size: 1.7rem;
          text-align: left;
          span {
            font-size: 1.4rem;
          }
        }
        button {
          /* transition: 0.3s; */
          cursor: pointer;
          margin: 0 0.5rem;
          &.first-btn {
            padding: 18px 42px;
            margin-right:25px;
            background: ${({ fontColor }) => (fontColor ? COLORS.white : COLORS.primaryBackground)};
            color: ${({ fontColor }) => (fontColor ? COLORS.primaryBackground : COLORS.white)};
            border-radius: 4px;
          }
          &.sec-btn {
            color: rgba(181, 206, 255, 1);
            background: transparent;
            font-size: 1.7rem;
            text-align: left;
            span {
              font-size: 1.4rem;
            }
          }
          /* :hover {
            transform: translateY(-5px);
          } */
        }
      }
    }
    .img-content {
      width: 60%;
      z-index: ${({ zIndex }) => zIndex};
      img {
        height: auto;
        width: 100%;
      }
      /* @media all and (max-width: 768px) {
        display: none;
      } */
      @media all and (max-width: 1024px) {
        width: 100%;
      }
    }
    @media all and (max-width: 1024px) {
      margin: 15rem 2rem 9rem 2rem;
      flex-direction: column-reverse;
    }
  }
  .text-content {
    text-align: left;
    padding: 0 20px;
    margin-top: 7.5rem;
    color: ${({ fontColor }) => (fontColor ? COLORS.white : COLORS.black)};

    .title-tip {
      font-size: 1.4rem;
      line-height: 1.7rem;
      letter-spacing: 0.15em;
      color: #5a189a;
    }

    .title {
      line-height: 5.5rem;
      font-size: 4.8rem;
      font-weight: bold;
      max-width: 828px;
      opacity: 1;

      @media all and (max-width: 470px) {
        line-height: 4.8rem;
      }
    }
    .desc {
      max-width: 715px;
      margin: 0 auto;
      font-size: 1.7rem;
      line-height: 2.8rem;

      .dot {
        width: 0.6rem;
        height: 0.6rem;
        background: #e5e5e5;
        border-radius: 50%;
      }
    }
    .btn {
      margin-top: 4.8rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      div {
        display: flex;
        align-items: center;
        font-weight: normal;
        @media all and (max-width: 391px) {
          margin-top: 20px;
        }
        svg {
          margin: 0 10px;
        }
      }
      .sec-link {
        color: rgba(181, 206, 255, 1);
        background: transparent;
        font-size: 1.7rem;
        text-align: left;
        span {
          font-size: 1.4rem;
        }
      }
      button {
        /* transition: 0.3s; */
        cursor: pointer;
        margin: 0 0.5rem;
        &.first-btn {
          padding: 18px 42px;
          margin-right: 25px;
          background: ${({ fontColor }) => (fontColor ? COLORS.white : COLORS.primaryBackground)};
          color: ${({ fontColor }) => (fontColor ? COLORS.primaryBackground : COLORS.white)};
          border-radius: 4px;
        }
        &.sec-btn {
          color: rgba(181, 206, 255, 1);
          background: transparent;
          font-size: 1.7rem;
          text-align: left;
          span {
            font-size: 1.4rem;
          }
        }
        /* :hover {
          transform: translateY(-5px);
        } */
      }
    }
  }
`;
